import { GiftingLocalCart, NativeLocalCart } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export enum CART_JOURNEY_ADDITIONAL_CONTEXT_KEYS {
    MOVIE_BEAM = "moviebeam",
}

export const isMovieBeamContextExists = (localcart: NativeLocalCart | GiftingLocalCart | null) => {
    const additionalContext = localcart?.cart_journey_ctx?.additional_context ?? {};

    return !isEmpty(additionalContext[CART_JOURNEY_ADDITIONAL_CONTEXT_KEYS.MOVIE_BEAM]);
}